<!-- <div class="howItWorks noselect" (click)="howItWorksDialog()">
  <span class="material-icons-outlined">play_circle_filled</span>
  {{'How it works?' | translate }}
</div> -->

<section id="blocksWrapper" [ngClass]="builderService.blocksCollapsed ? 'collapsedBlocks' : 'openedBlocks'" *ngIf="!builderService.globals">
  <h2 class="blocksWrapperTitle">{{ 'Add Components' | translate }}</h2>
  <block-static class="blockWrap blockStatic"></block-static>
  <block-text class="blockWrap"></block-text>
  <block-button class="blockWrap"></block-button>
  <block-image class="blockWrap"></block-image>
  <stacks-products  *ngIf="!this.vendor.isMultiVendor  && builderService.standalone" class="blockWrap"></stacks-products>
  <stacks-categories  *ngIf="!this.vendor.isMultiVendor && builderService.standalone" class="blockWrap"></stacks-categories>
  <block-slider class="blockWrap"></block-slider>
  <block-video class="blockWrap"></block-video>
  <block-section class="blockWrap"></block-section>
  <div class="wordPressText" *ngIf="this.vendor.isMultiVendor" style="display: flex">
      <p>{{ 'Multivendor Blocks' | translate }}</p>
    </div> 
  <vendor-products class="blockWrap" *ngIf="this.vendor.isMultiVendor"></vendor-products>
  <vendor-cats class="blockWrap" *ngIf="this.vendor.isMultiVendor"></vendor-cats>
  <multivendor class="blockWrap" *ngIf="this.vendor.isMultiVendor"></multivendor>
  <block-products *ngIf="!builderService.standalone" class="blockWrap"></block-products>
  <block-categories *ngIf="!builderService.standalone" class="blockWrap"></block-categories>
  <block-posts *ngIf="!builderService.standalone" class="blockWrap"></block-posts>
  <block-reviews class="blockWrap"></block-reviews>
  <block-announcement-bar *ngIf="isWebsiteBuilderRoute()" class="blockWrap"></block-announcement-bar>
  <block-sidemenu *ngIf="!isWebsiteBuilderRoute()" class="blockWrap" cdkDragDisabled="true"></block-sidemenu>
  <block-header class="blockWrap blockHeader" cdkDragDisabled="true"></block-header>
  <block-footer class="blockWrap blockFooter" cdkDragDisabled="true"></block-footer>
  <div *ngIf="!builderService.standalone">
    <div class="wordPressText" style="display: flex">
      <p>{{ 'Native Stacks Blocks' | translate }}</p>
    </div>
    <div class="disabledBlocksWrapper">
      <stacks-products class="blockWrap"></stacks-products>
      <stacks-categories class="blockWrap"></stacks-categories>
    </div>
  </div>
</section>

<section id="blocksWrapper" [ngClass]="builderService.blocksCollapsed ? 'collapsedBlocks' : 'openedBlocks'" *ngIf="builderService.globals">
  <h2 class="blocksWrapperTitle">{{ 'Add Components' | translate }}</h2>
  <block-header class="blockWrap blockHeader" cdkDragDisabled="true"></block-header>
  <block-text class="blockWrap" cdkDragDisabled="true"></block-text>
  <block-image class="blockWrap" cdkDragDisabled="true"></block-image>
  <block-section class="blockWrap" cdkDragDisabled="true"></block-section>
  <stacks-products *ngIf="builderService.standalone" class="blockWrap" cdkDragDisabled="true"></stacks-products>
  <stacks-categories *ngIf="builderService.standalone" class="blockWrap" cdkDragDisabled="true"></stacks-categories>
  <block-slider class="blockWrap" cdkDragDisabled="true"></block-slider>
  <block-video class="blockWrap" cdkDragDisabled="true"></block-video>
  <block-button class="blockWrap" cdkDragDisabled="true"></block-button>
  <block-reviews class="blockWrap" cdkDragDisabled="true"></block-reviews>
  <block-footer class="blockWrap blockFooter" cdkDragDisabled="true"></block-footer>
  <block-sidemenu class="blockWrap" cdkDragDisabled="true"></block-sidemenu>
  <button mat-icon-button (click)="blocksHome()" class="blocksHomeMobile" *ngIf="mobile">
    <mat-icon class="material-icons material-icons-outlined">build</mat-icon>
    {{ 'Blocks' | translate }}
  </button>
</section>
